import Logo from "../../../assets/logos/Oasis_1c_inverted.png"

const LogoWhite = () => {
    return (
        <img
            src={Logo}
            width="113px"
            height="56px"
            alt="oasis-logo"
        />
    )
}

export default LogoWhite;